export enum Display {
  flex = 'flex',
  none = 'none',
}
